import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { TtOrderMetadata } from '@/lib/api/risk/brokerage/tt';
import { AttachCustomerForm } from './AttachCustomerForm';

interface OrderTextFields {
  textA?: string | null;
  textB?: string | null;
  textC?: string | null;
  textTT?: string | null;
}

interface AttachCustomerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  guidOrderId: string;
  existingMetadata?: TtOrderMetadata | null;
  orderTextFields?: OrderTextFields;
}

export function AttachCustomerModal({
  open,
  onOpenChange,
  guidOrderId,
  existingMetadata,
  orderTextFields,
}: AttachCustomerModalProps) {
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] md:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Attach Customer Info</DialogTitle>
        </DialogHeader>
        <AttachCustomerForm
          guidOrderId={guidOrderId}
          existingMetadata={existingMetadata}
          onSuccess={handleSuccess}
          orderTextFields={orderTextFields}
          isModal
        />
      </DialogContent>
    </Dialog>
  );
}
